import React, { useState } from 'react';
import { submitFeedback } from '../shared/questionsTx';
import { auth } from '../firebase';
import { NeonText, CyberButton } from './CyberEffects';
import './FeedbackModal.css';

// フィードバックの種類
const FEEDBACK_TYPES = [
  { value: 'wrong_answer', label: '答えが間違っている' },
  { value: 'ambiguous', label: '問題文があいまい' },
  { value: 'too_easy', label: '簡単すぎる' },
  { value: 'too_hard', label: '難しすぎる' },
  { value: 'typo', label: '誤字・脱字がある' },
  { value: 'other', label: 'その他' },
];

function FeedbackModal({ isOpen, onClose, questionId, questionPrompt }) {
  const [feedbackType, setFeedbackType] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!feedbackType) {
      setError('フィードバックの種類を選択してください');
      return;
    }

    if (!auth.currentUser) {
      setError('ログインが必要です');
      return;
    }

    setSubmitting(true);
    try {
      const result = await submitFeedback({
        questionId,
        questionPrompt,
        feedbackType,
        message: message.trim(),
      });

      if (result.ok) {
        setSuccess(true);
        setTimeout(() => {
          handleClose();
        }, 2000);
      } else {
        setError('送信に失敗しました: ' + result.reason);
      }
    } catch (e) {
      setError('エラーが発生しました: ' + e.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setFeedbackType('');
    setMessage('');
    setError('');
    setSuccess(false);
    onClose();
  };

  return (
    <div className="feedback-overlay" onClick={handleClose}>
      <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>×</button>

        <h2 className="modal-title">
          <NeonText color="blue" size="md">問題のフィードバック</NeonText>
        </h2>

        {questionPrompt && (
          <div className="feedback-question">
            <span className="question-label">対象の問題:</span>
            <p className="question-text">{questionPrompt}</p>
          </div>
        )}

        {success ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <p>フィードバックを送信しました</p>
            <p className="success-note">ご協力ありがとうございます</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="form-row">
              <label>フィードバックの種類</label>
              <div className="feedback-type-options">
                {FEEDBACK_TYPES.map(type => (
                  <label key={type.value} className="feedback-type-option">
                    <input
                      type="radio"
                      name="feedbackType"
                      value={type.value}
                      checked={feedbackType === type.value}
                      onChange={(e) => setFeedbackType(e.target.value)}
                    />
                    <span>{type.label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-row">
              <label>詳細（任意）</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="具体的な内容があれば入力してください"
                rows={3}
                maxLength={500}
              />
            </div>

            {error && <p className="error-message">{error}</p>}

            <div className="form-actions">
              <button type="button" className="cancel-btn" onClick={handleClose}>
                キャンセル
              </button>
              <CyberButton
                type="submit"
                variant="primary"
                disabled={submitting || !feedbackType}
              >
                {submitting ? '送信中...' : '送信'}
              </CyberButton>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default FeedbackModal;
